import Text from '@deprecated-ui/common/Text';
import { Select } from '../styled';

const OptionGroup = ({ children, ...otherProps }: any) => (
  <Select.Option {...otherProps}>
    <Text height="inherit">{children}</Text>
  </Select.Option>
);

export default OptionGroup;
